import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ILocationOverview, ILocation } from '@/types/location/models'
import type { ICompany } from '~/types/company/models'

const apiEntityPath = '/api/locations'

export async function getLocationOverview(id: string) {
  const callingMn = getLocationOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<ILocationOverview>({ callingMn, apiPath })
}

export async function getLocation(id: TEntityId) {
  const callingMn = getLocation.name
  const apiPath = `${apiEntityPath}/${id}`
  return httpGet<ILocation>({ callingMn, apiPath })
}

export async function createLocation(entity: ILocation) {
  const callingMn = createLocation.name
  const apiPath = apiEntityPath
  return httpPost<ILocation>({ callingMn, apiPath, entity })
}

export async function updateLocation(
  entityData: Partial<ILocation>,
  id: TEntityId
) {
  const callingMn = updateLocation.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialILocation = Partial<ILocation>
  return httpPatchMerge<TPartialILocation>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLocation(entityData: ILocation) {
  const callingMn = deleteLocation.name
  const apiPath = apiEntityPath
  return httpDelete<ILocation>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function getCompanyFromLocation(id: TEntityId) {
  const callingMn = getCompanyFromLocation.name
  const apiPath = `${apiEntityPath}/${id}/company`
  return httpGet<ICompany>({ callingMn, apiPath })
}
